<template>
  <div class="signup-fullscreen-wrapper">
    <div class="page-wrapper min-vh-100 d-flex align-items-center">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6 col-md-8 col-12">
            <div class="card shadow-lg border-0">
              <div class="card-header bg-transparent text-start pt-4 pb-3 px-4">
                <h3 class="font-weight-bolder text-success mb-1">
                  Create Account
                </h3>
                <p class="mb-0 text-sm text-secondary">
                  Register your organization to get started
                </p>
              </div>
              <div class="card-body px-4 pb-2">
                <form
                  role="form"
                  @submit.prevent="handleSubmit"
                  autocomplete="off"
                >
                  <div style="display: none; height: 0; overflow: hidden">
                    <input
                      type="text"
                      name="dummy_username"
                      autocomplete="off"
                    />
                    <input
                      type="password"
                      name="dummy_password"
                      autocomplete="new-password"
                    />
                    <input type="email" name="dummy_email" autocomplete="off" />
                  </div>

                  <div class="mb-2">
                    <material-input
                      id="org_name"
                      :value="formData.company"
                      @input="
                        formData.company = $event.target
                          ? $event.target.value
                          : $event
                      "
                      type="text"
                      label="Company/Organization Name"
                      name="org_name"
                      size="lg"
                      required
                      autocomplete="off"
                      :disabled="isLoading"
                    />
                  </div>

                  <div class="row mb-2">
                    <div class="col-md-12 mb-3 mb-md-0">
                      <material-input
                        id="op_id_field"
                        :value="formData.operatorId"
                        @input="
                          formData.operatorId = $event.target
                            ? $event.target.value
                            : $event
                        "
                        type="text"
                        label="Operator ID"
                        name="op_id_field"
                        size="lg"
                        required
                        autocomplete="off"
                        :disabled="isLoading"
                      />
                    </div>
                  </div>

                  <div class="mb-2">
                    <material-input
                      id="user_email"
                      :value="formData.email"
                      @input="
                        formData.email = $event.target
                          ? $event.target.value
                          : $event
                      "
                      @blur="validateEmail"
                      @focus="changeInputType($event, 'email')"
                      type="text"
                      label="Email Address"
                      name="user_email"
                      size="lg"
                      required
                      autocomplete="off"
                      :disabled="isLoading"
                    />
                    <small v-if="emailError" class="text-danger d-block mt-1">
                      <i class="fas fa-exclamation-circle me-1"></i>
                      {{ emailError }}
                    </small>
                  </div>

                  <div class="mb-3">
                    <material-input
                      id="org_contact"
                      :value="formData.contact"
                      @input="
                        formData.contact = $event.target
                          ? $event.target.value
                          : $event
                      "
                      type="number"
                      label="Telephone Number"
                      name="org_contact"
                      size="lg"
                      required
                      autocomplete="off"
                      :disabled="isLoading"
                    />
                  </div>

                  <div class="mb-3">
                    <div class="position-relative">
                      <material-input
                        id="new_pass"
                        :value="formData.password"
                        @input="handlePasswordInput($event)"
                        :type="showPassword ? 'text' : 'password'"
                        label="Password"
                        name="new_pass"
                        size="lg"
                        required
                        autocomplete="new-password"
                        :disabled="isLoading"
                      />
                      <button
                        type="button"
                        class="password-toggle-btn"
                        @click="showPassword = !showPassword"
                        aria-label="Toggle password visibility"
                        :disabled="isLoading"
                      >
                        <i
                          :class="
                            showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'
                          "
                        ></i>
                      </button>
                    </div>

                    <div
                      v-if="formData.password"
                      class="password-requirements mt-2"
                    >
                      <small class="d-block mb-2 fw-bold text-dark">
                        <i class="fas fa-shield-alt me-1"></i>
                        Password Requirements:
                      </small>
                      <div class="row">
                        <div class="col-6">
                          <small
                            class="d-block mb-2"
                            :class="
                              passwordRequirements.length
                                ? 'text-success'
                                : 'text-danger'
                            "
                          >
                            <i
                              :class="
                                passwordRequirements.length
                                  ? 'fas fa-check-circle'
                                  : 'fas fa-times-circle'
                              "
                            ></i>
                            Minimum 8 characters
                          </small>
                        </div>
                        <div class="col-6">
                          <small
                            class="d-block mb-2"
                            :class="
                              passwordRequirements.uppercase
                                ? 'text-success'
                                : 'text-danger'
                            "
                          >
                            <i
                              :class="
                                passwordRequirements.uppercase
                                  ? 'fas fa-check-circle'
                                  : 'fas fa-times-circle'
                              "
                            ></i>
                            At least 1 uppercase letter
                          </small>
                        </div>
                        <div class="col-6">
                          <small
                            class="d-block mb-2"
                            :class="
                              passwordRequirements.lowercase
                                ? 'text-success'
                                : 'text-danger'
                            "
                          >
                            <i
                              :class="
                                passwordRequirements.lowercase
                                  ? 'fas fa-check-circle'
                                  : 'fas fa-times-circle'
                              "
                            ></i>
                            At least 1 lowercase letter
                          </small>
                        </div>
                        <div class="col-6">
                          <small
                            class="d-block mb-2"
                            :class="
                              passwordRequirements.number
                                ? 'text-success'
                                : 'text-danger'
                            "
                          >
                            <i
                              :class="
                                passwordRequirements.number
                                  ? 'fas fa-check-circle'
                                  : 'fas fa-times-circle'
                              "
                            ></i>
                            At least 1 number
                          </small>
                        </div>
                      </div>
                      <small class="d-block mt-1 text-muted">
                        <i class="fas fa-info-circle me-1"></i>
                        Special characters (optional but recommended)
                      </small>
                    </div>
                  </div>

                  <div class="mb-4">
                    <div class="position-relative">
                      <material-input
                        id="confirm_new_pass"
                        :value="formData.confirmPassword"
                        @input="handleConfirmPasswordInput($event)"
                        :type="showConfirmPassword ? 'text' : 'password'"
                        label="Confirm Password"
                        name="confirm_new_pass"
                        size="lg"
                        required
                        autocomplete="new-password"
                        :disabled="isLoading"
                      />
                      <button
                        type="button"
                        class="password-toggle-btn"
                        @click="showConfirmPassword = !showConfirmPassword"
                        aria-label="Toggle password visibility"
                        :disabled="isLoading"
                      >
                        <i
                          :class="
                            showConfirmPassword
                              ? 'fas fa-eye-slash'
                              : 'fas fa-eye'
                          "
                        ></i>
                      </button>
                    </div>

                    <div
                      v-if="formData.password || formData.confirmPassword"
                      class="mt-2"
                    >
                      <small
                        v-if="passwordMatchError"
                        class="text-danger d-block"
                      >
                        <i class="fas fa-exclamation-triangle me-1"></i>
                        {{ passwordMatchError }}
                      </small>
                      <small
                        v-else-if="
                          formData.confirmPassword &&
                          passwordsMatch &&
                          formData.password
                        "
                        class="text-success d-block"
                      >
                        <i class="fas fa-check-circle me-1"></i>
                        Passwords match ✓
                      </small>
                      <small
                        v-else-if="
                          formData.confirmPassword && !formData.password
                        "
                        class="text-warning d-block"
                      >
                        <i class="fas fa-exclamation-circle me-1"></i>
                        Please enter your password first
                      </small>
                    </div>
                  </div>

                  <div class="mb-2">
                    <material-checkbox
                      id="termsCheckbox"
                      class="font-weight-light"
                      :checked="formData.termsAccepted"
                      @change="formData.termsAccepted = $event.target.checked"
                      :disabled="isLoading"
                    >
                      I agree to the
                      <a
                        href=" "
                        class="text-success font-weight-bolder"
                        target="_blank"
                        >Terms and Conditions</a
                      >
                      and
                      <a
                        href=" "
                        class="text-success font-weight-bolder"
                        target="_blank"
                        >Privacy Policy</a
                      >
                    </material-checkbox>
                  </div>

                  <div class="text-center">
                    <material-button
                      class="mt-1 mb-1"
                      variant="gradient"
                      color="success"
                      fullWidth
                      size="lg"
                      type="submit"
                      :disabled="isLoading"
                    >
                      <span v-if="isLoading">
                        <i class="fas fa-spinner fa-spin me-2"></i>
                        Creating Account...
                      </span>
                      <span v-else>
                        <i class="fas fa-user-plus me-2"></i>
                        Create Account
                      </span>
                    </material-button>
                  </div>
                </form>
              </div>
              <div
                class="card-footer bg-transparent px-4 pt-0 pb-4 text-center"
              >
                <p class="mb-0 text-sm text-secondary">
                  Already have an account?
                  <router-link
                    :to="{ name: 'SignIn' }"
                    class="text-success text-gradient font-weight-bold"
                  >
                    Sign In
                  </router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import MaterialButton from "@/components/MaterialButton.vue";
const body = document.getElementsByTagName("body")[0];
import { mapMutations } from "vuex";
import axios from "axios";

export default {
  name: "sign-up",
  components: {
    MaterialInput,
    MaterialCheckbox,
    MaterialButton,
  },
  data() {
    return {
      formData: {
        company: "",
        operatorId: "",
        email: "",
        contact: "",
        password: "",
        confirmPassword: "",
        termsAccepted: false,
      },
      showPassword: false,
      showConfirmPassword: false,
      passwordRequirements: {
        length: false,
        uppercase: false,
        lowercase: false,
        number: false,
      },
      emailError: "",
      passwordMatchError: "",
      isLoading: false,
    };
  },
  computed: {
    isPasswordValid() {
      return Object.values(this.passwordRequirements).every(Boolean);
    },
    passwordsMatch() {
      return this.formData.password === this.formData.confirmPassword;
    },
  },
  mounted() {
    // Hide navbar and sidebar when signup page mounts
    this.hideLayoutElements();

    // Remove any body classes from main layout
    document.body.classList.remove("g-sidenav-show", "g-sidenav-pinned");
    document.body.style.overflow = "hidden";

    // Force layout elements to be hidden
    this.forceHideLayout();
  },
  beforeMount() {
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    // Restore when leaving signup page
    this.restoreLayoutElements();
    document.body.style.overflow = "";
    body.classList.add("bg-gray-100");
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),

    hideLayoutElements() {
      // Hide all layout elements
      const elementsToHide = [
        ".sidenav",
        ".navbar",
        ".app-footer",
        ".main-content > nav",
        ".main-content > footer",
      ];

      elementsToHide.forEach((selector) => {
        const elements = document.querySelectorAll(selector);
        elements.forEach((el) => {
          if (el) {
            el.style.display = "none";
            el.classList.add("d-none");
          }
        });
      });

      // Remove any margin from main wrapper
      const mainWrapper = document.querySelector(".main-wrapper");
      if (mainWrapper) {
        mainWrapper.style.marginLeft = "0";
        mainWrapper.style.width = "100%";
        mainWrapper.classList.add("fullscreen-signup");
      }

      // Hide the entire app wrapper content except signup
      const appWrapper = document.querySelector(".app-wrapper");
      if (appWrapper) {
        appWrapper.style.display = "block";
      }
    },

    forceHideLayout() {
      // Additional forced hiding
      setTimeout(() => {
        const navbar = document.querySelector("nav");
        const sidebar = document.querySelector("aside");
        const footer = document.querySelector("footer");

        if (navbar) {
          navbar.style.display = "none";
          navbar.style.opacity = "0";
          navbar.style.visibility = "hidden";
          navbar.style.position = "absolute";
        }

        if (sidebar) {
          sidebar.style.display = "none";
          sidebar.style.opacity = "0";
          sidebar.style.visibility = "hidden";
          sidebar.style.position = "absolute";
        }

        if (footer) {
          footer.style.display = "none";
        }
      }, 100);
    },

    restoreLayoutElements() {
      // Show layout elements again
      const elementsToShow = [
        ".sidenav",
        ".navbar",
        ".app-footer",
        ".main-content > nav",
        ".main-content > footer",
      ];

      elementsToShow.forEach((selector) => {
        const elements = document.querySelectorAll(selector);
        elements.forEach((el) => {
          if (el) {
            el.style.display = "";
            el.classList.remove("d-none");
          }
        });
      });

      // Restore main wrapper
      const mainWrapper = document.querySelector(".main-wrapper");
      if (mainWrapper) {
        mainWrapper.style.marginLeft = "";
        mainWrapper.style.width = "";
        mainWrapper.classList.remove("fullscreen-signup");
      }

      // Restore app wrapper
      const appWrapper = document.querySelector(".app-wrapper");
      if (appWrapper) {
        appWrapper.style.display = "";
      }
    },

    changeInputType(event, type) {
      if (event.target && event.target.type !== type) {
        event.target.type = type;
      }
    },

    handlePasswordInput(event) {
      const value = event.target ? event.target.value : event;
      this.formData.password = value;
      this.validatePasswordRequirements();
      this.checkPasswordMatch();
    },

    handleConfirmPasswordInput(event) {
      const value = event.target ? event.target.value : event;
      this.formData.confirmPassword = value;
      this.checkPasswordMatch();
    },

    validatePasswordRequirements() {
      const password = this.formData.password;
      this.passwordRequirements = {
        length: password.length >= 8,
        uppercase: /[A-Z]/.test(password),
        lowercase: /[a-z]/.test(password),
        number: /[0-9]/.test(password),
      };
    },

    checkPasswordMatch() {
      if (!this.formData.password && this.formData.confirmPassword) {
        this.passwordMatchError = "Please enter your password first";
        return;
      }

      if (this.formData.password && this.formData.confirmPassword) {
        if (this.formData.password !== this.formData.confirmPassword) {
          this.passwordMatchError = "Passwords do not match";
        } else {
          this.passwordMatchError = "";
        }
      } else {
        this.passwordMatchError = "";
      }
    },

    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (this.formData.email && !emailRegex.test(this.formData.email)) {
        this.emailError =
          "Please enter a valid email address (e.g., name@company.com)";
      } else {
        this.emailError = "";
      }
    },

    async handleSubmit() {
      this.validateEmail();
      this.checkPasswordMatch();

      if (
        !this.formData.company.trim() ||
        !this.formData.operatorId.trim() ||
        !this.formData.contact ||
        !this.formData.email.trim() ||
        !this.formData.password ||
        !this.formData.confirmPassword ||
        !this.formData.termsAccepted
      ) {
        this.showNotification("Please fill in all required fields", "error");
        return;
      }

      if (this.emailError) {
        this.showNotification("Please enter a valid email address", "error");
        return;
      }

      if (!this.isPasswordValid) {
        this.showNotification(
          "Password does not meet all requirements",
          "error",
        );
        return;
      }

      if (this.passwordMatchError) {
        this.showNotification("Passwords do not match", "error");
        return;
      }

      await this.submitForm();
    },

    showNotification(message, type = "success") {
      // Remove any existing notifications
      const existingAlerts = document.querySelectorAll(".fixed-notification");
      existingAlerts.forEach((alert) => alert.remove());

      const notification = document.createElement("div");
      notification.className = `alert alert-${
        type === "error" ? "danger" : "success"
      } alert-dismissible fade show fixed-notification`;
      notification.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 9999;
        min-width: 300px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      `;

      notification.innerHTML = `
        <strong>${type === "error" ? "Error!" : "Success!"}</strong> ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
      `;

      document.body.appendChild(notification);

      setTimeout(() => {
        if (notification.parentNode) {
          notification.remove();
        }
      }, 5000);
    },

    async submitForm() {
      this.isLoading = true;

      try {
        this.showNotification("Creating your account...", "info");

        const registrationData = {
          business_name: this.formData.company.trim(),
          business_contact: this.formData.contact,
          operator_id: this.formData.operatorId.trim(),
          business_email: this.formData.email.trim(),
          password: this.formData.password,
        };

        const response = await axios.post("/operators/", registrationData);

        // Check for successful response
        if (response.status === 201 || response.status === 200) {
          console.log("Registration successful:", response.data);

          this.showNotification(
            "Account created successfully! Redirecting to sign in...",
            "success",
          );

          this.resetForm();

          // Redirect to sign-in page
          setTimeout(() => {
            this.$router.push({ name: "SignIn" });
          }, 2000);
        } else {
          throw new Error("Registration failed. Please try again.");
        }
      } catch (error) {
        console.error("Registration error:", error);

        let errorMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Registration failed. Please try again.";

        // Handle specific error cases
        if (error.response?.status === 409) {
          errorMessage =
            "Email or operator ID already exists. Please use different credentials.";
        } else if (error.response?.status === 400) {
          if (error.response.data?.errors) {
            const errors = Object.values(error.response.data.errors).flat();
            errorMessage = errors.join(", ");
          } else if (error.response.data?.message) {
            errorMessage = error.response.data.message;
          }
        } else if (error.code === "ERR_NETWORK") {
          errorMessage =
            "Registration endpoint not found. Please contact support.";
        } else if (error.response?.status == 404) {
          errorMessage =
            "Registration endpoint not found. Please contact support.";
        }

        this.showNotification(errorMessage, "error");
      } finally {
        this.isLoading = false;
      }
    },

    resetForm() {
      this.formData = {
        company: "",
        operatorId: "",
        email: "",
        password: "",
        confirmPassword: "",
        termsAccepted: false,
      };
      this.showPassword = false;
      this.showConfirmPassword = false;
      this.passwordRequirements = {
        length: false,
        uppercase: false,
        lowercase: false,
        number: false,
      };
      this.emailError = "";
      this.passwordMatchError = "";
    },
  },
};
</script>

<style scoped>
.signup-fullscreen-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    #f8f9fa 0%,
    #e9ecef 25%,
    #dee2e6 50%,
    #e9ecef 75%,
    #f8f9fa 100%
  );
  z-index: 9999;
  overflow-y: auto;
}

.page-wrapper {
  position: relative;
  padding: 2rem 0;
  min-height: 100vh;
}

.card {
  border: none;
  box-shadow: 0 20px 40px 0 rgba(255, 140, 50, 0.12);
  border-radius: 1rem;
  background: #ffffff;
}

.password-toggle-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  color: #6c757d;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;
}

.password-toggle-btn:hover:not(:disabled) {
  color: #4caf50;
}

.password-toggle-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.password-toggle-btn:focus {
  outline: none;
}

.password-toggle-btn i {
  font-size: 1rem;
}

.position-relative :deep(input),
.position-relative :deep(.form-control) {
  padding-right: 45px !important;
}

.password-requirements {
  padding: 12px;
  background: #f8f9fa;
  border-radius: 0.5rem;
  border: 1px solid #e9ecef;
  margin-top: 8px;
}

.password-requirements small {
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

.password-requirements small i {
  font-size: 0.7rem;
  width: 16px;
}

.text-success {
  color: #4caf50 !important;
}

.text-danger {
  color: #f44336 !important;
}

.text-warning {
  color: #ff9800 !important;
}

.text-gradient {
  background-image: linear-gradient(310deg, #4caf50 0%, #66bb6a 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.material-button {
  transition: all 0.3s ease;
}

.material-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 10px 20px rgba(76, 175, 80, 0.3);
}

@media (max-width: 767.98px) {
  .password-requirements .col-6 {
    width: 100% !important;
  }

  .page-wrapper {
    padding: 1rem 0;
  }

  .row.mb-3 .col-md-6 {
    margin-bottom: 1rem !important;
  }

  .row.mb-3 .col-md-6:last-child {
    margin-bottom: 0 !important;
  }
}
</style>

<style>
.fullscreen-signup {
  margin-left: 0 !important;
  width: 100% !important;
}

.signup-fullscreen-wrapper ~ .sidenav,
.signup-fullscreen-wrapper ~ .navbar,
.signup-fullscreen-wrapper ~ footer {
  display: none !important;
  opacity: 0 !important;
  visibility: hidden !important;
}

body:has(.signup-fullscreen-wrapper) {
  overflow: hidden !important;
}
</style>
